import Apis from 'apis';
import { objToQueryString } from 'utils/helpers';

export const api = Apis({});

interface QueryProps {
  limit?: number | string;
  offset?: number | string;
  search?: string;
}

export default {
  getAllClients: (query: QueryProps) => `/client/?${objToQueryString(query)}`,
  getAllClientsOperator: (query: QueryProps) =>
    `/client/summary/?${objToQueryString(query)}`,
  enableOrDisableRemoteProfile: (clientId: string, userId: string) =>
    `/client/${clientId}/user/${userId}/`,
  removeAllClient: (clientId: string) =>
    `/client/${clientId}/user/remove-users/`,
  activeAllClient: (clientId: string) =>
    `/client/${clientId}/user/multiple-activate/`,
  inactivateAllClient: (clientId: string) =>
    `/client/${clientId}/user/multiple-inactivate/`,
  getAllHistorySession: (clientUuid: string, query: QueryProps) =>
    `/client/${clientUuid}/session-history/?${objToQueryString(query)}`,
  exportHistorySessionCSV: (clientUuid: string, query: QueryProps) =>
    `/client/${clientUuid}/session-history/export/?${objToQueryString(query)}`,
  newClientApplication: (clientUuid: string, type: string) =>
    `/client/${clientUuid}/apps/${type}/`,
  activeAllUserMFA: (clientUuid: string) =>
    `/client/${clientUuid}/user/switch-mfa/`,
  resetMFAUser: (clientUuid: string, userUuid: string) =>
    `/client/${clientUuid}/user/${userUuid}/reset-mfa/`,
  editClientApplication: (clientUuid: string, type: string, appUuid: string) =>
    `/client/${clientUuid}/apps/${type}/${appUuid}/`,
  getClientApplications: (
    query: QueryProps,
    clientUuid: string,
    type: string
  ) => `/client/${clientUuid}/apps/${type}/?${objToQueryString(query)}`,
  getAvailableApplications: (clientUuid: string, query: QueryProps) =>
    `/client/${clientUuid}/apps/platform/available/?${objToQueryString(query)}`,
  applyConfigApplication: (clientUuid: string, type: string) =>
    `/client/${clientUuid}/apps/platform/${type}/`,
  removeClientApplication: (clientUuid: string, appUuid?: string) =>
    appUuid
      ? `/client/${clientUuid}/apps/autosky/${appUuid}/`
      : `/client/${clientUuid}/apps/platform/remove/`,
  getClientUser: (query: QueryProps, clientUuid: string) =>
    `/client/${clientUuid}/user/?${objToQueryString(query)}`,
  getClientById: (clientUuid: string) => `/client/${clientUuid}/`,
  removeClient: (clientUuid: string) => `/client/${clientUuid}/`,
  newClient: () => `/client/`,
  editClient: (clientUuid: string) => `/client/${clientUuid}/`,
  newCloneClient: (clientUuid: string) => `/client/${clientUuid}/clone/`,
  createUserInClient: (clientUuid: string) => `/client/${clientUuid}/user/`,
  inactiveUserInClient: (clientUuid: string, userUuid: string) =>
    `/client/${clientUuid}/user/${userUuid}/inactivate/`,
  activeUserInClient: (clientUuid: string, userUuid: string) =>
    `/client/${clientUuid}/user/${userUuid}/activate/`,
  removeClientUser: (clientUuid: string, userUuid: string) =>
    `/client/${clientUuid}/user/${userUuid}/`,
  editClientUser: (clientUuid: string, userUuid: string) =>
    `/client/${clientUuid}/user/${userUuid}/`,
  clientSession: (clientUuid: string, query: QueryProps) =>
    `/session/?client_uuid=${clientUuid}&${objToQueryString(query)}`,
  removeSessions: () => `/session/remove-sessions/`,

  getMaintenanceDisplayWarning: (clientUuid: string) =>
    `/client/${clientUuid}/maintenance/display-warning/`,
  getMaintenanceSchedule: (clientUuid: string) =>
    `client/${clientUuid}/maintenance/schedule/`,

  getMaintenanceImmediate: (clientUuid: string) =>
    `client/${clientUuid}/maintenance/immediate/`,

  editMaintenanceDisplayWarning: (clientUuid: string) =>
    `client/${clientUuid}/maintenance/display-warning/`,
  editMaintenanceSchedule: (clientUuid: string) =>
    `client/${clientUuid}/maintenance/schedule/`,

  editMaintenanceImmediate: (clientUuid: string) =>
    `client/${clientUuid}/maintenance/immediate/`,
  sendEmailToResetPassword: (clientUuid: string, userUuid: string) =>
    `/client/${clientUuid}/user/${userUuid}/reset-password/`,
  testOpenApplication: (clientUuid: string) =>
    `/client/${clientUuid}/apps/autosky/simulate/`,

  settingsAccessControl: (clientUuid: string) =>
    `/client/${clientUuid}/access-control/settings/`,
  allowedIps: (clientUuid: string) =>
    `/client/${clientUuid}/access-control/allowed-ips/`,
  blockedPeriods: (clientUuid: string) =>
    `/client/${clientUuid}/access-control/blocked-periods/`,
  exportUsersCSV: (clientUuid: string) => `/client/${clientUuid}/user/export/`,
  importUsersCSV: (clientUuid: string, custom: boolean) =>
    `/client/${clientUuid}/user/import${custom ? '-custom' : ''}/`,
  importClientsCSV: (clientUuid: string) => `/client/${clientUuid}/import/`,

  activateMultipleApplications: (clientUuid: string) =>
    `/client/${clientUuid}/apps/autosky/activate-applications/`,

  inactivateMultipleApplications: (clientUuid: string) =>
    `/client/${clientUuid}/apps/autosky/inactivate-applications/`,
  removeMultipleApplications: (clientUuid: string) =>
    `/client/${clientUuid}/apps/autosky/remove-applications/`,
  getAllUsers: (query: QueryProps) => `/user/?${objToQueryString(query)}`,
  getBlockMultipleSessionReport: (filters: QueryProps) =>
    `/client/report/block-multiple-session/?${objToQueryString(filters)}`,
  getConnectionTypeReport: (filters: QueryProps) =>
    `/client/report/connection-type/?${objToQueryString(filters)}`,
  getMFAReport: (filters: QueryProps) =>
    `/client/report/mfa/?${objToQueryString(filters)}`,
  getUseProfileReport: (filters: QueryProps) =>
    `/client/report/use-profile/?${objToQueryString(filters)}`,
  getClientVirtualizerReport: (filters: QueryProps) =>
    `/client/report/virtualizer/?${objToQueryString(filters)}`,
  getActivateReport: (filtersDashboard?: string) =>
    `/user/report/activate/?${filtersDashboard}`,
  getMFAUsersReport: (filtersDashboard?: string) =>
    `/user/report/mfa/?${filtersDashboard}`,
  getSaltReport: (filtersDashboard?: string) =>
    `/user/report/salt/?${filtersDashboard}`,
  exportClientSummary: (query: QueryProps) =>
    `/client/summary/export/?${objToQueryString(query)}`,
  exportUserSummary: (query: QueryProps) =>
    `/user/export/?${objToQueryString(query)}`,
  removeClientWebApplication: (clientUuid: string, appUuid?: string) =>
    `/client/${clientUuid}/apps/web/${appUuid}/`,
  activateForceResetPasswordSelectedUsers: (clientUuid: string) =>
    `/client/${clientUuid}/user/activate-reset-password-at-login/`,
  inactivateForceResetPasswordSelectedUsers: (clientUuid: string) =>
    `/client/${clientUuid}/user/inactivate-reset-password-at-login/`,
  enableUserDeviceValidationBypass: (clientId: string, userId: string) =>
    `/client/${clientId}/user/${userId}/enable-validation-bypass/`,
  disableUserDeviceValidationBypass: (clientId: string, userId: string) =>
    `/client/${clientId}/user/${userId}/disable-validation-bypass/`,
  getDigitalCertificates: (clientId: string, query: QueryProps) =>
    `/client/${clientId}/certificates/?${objToQueryString(query)}`,
  editDigitalCertificates: (clientId: string, certificateUuid: string) =>
    `/client/${clientId}/certificates/${certificateUuid}/`,
  deleteDigitalCertificates: (clientId: string, certificateUuid: string) =>
    `/client/${clientId}/certificates/${certificateUuid}/`,
  createDigitalCertificates: (clientId: string) =>
    `/client/${clientId}/certificates/`,
};
